import cx from 'classnames'
import React, { FocusEvent } from 'react'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'

import CheckboxInput from './filter-checkbox-input.component'

import * as styles from './filter-checkbox.module.css'

interface FilterCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  checked?: boolean
  input?: WrappedFieldInputProps
  meta?: WrappedFieldMetaProps
  isCustomCheckbox?: boolean
  onFocus?: (event: FocusEvent) => void
  onBlur?: (event: FocusEvent) => void
}

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({
  label,
  checked,
  isCustomCheckbox,
  onFocus,
  onBlur,
  ...props
}) => {
  const { children } = props
  const [focused, setFocused] = React.useState(false)

  const classNames = cx(styles.filterCheckbox, {
    [styles.filterCheckboxSelected]: checked,
    [styles.filterFocused]: focused,
  })

  const handleFocus = (event: FocusEvent) => {
    setFocused(true)
    if (onFocus) {
      onFocus(event)
    }
  }

  const handleBlur = (event: FocusEvent) => {
    setFocused(false)
    if (onBlur) {
      onBlur(event)
    }
  }

  return (
    <label className={classNames}>
      {isCustomCheckbox && <CheckboxInput className={styles.input} checked={checked} {...props} />}
      {!isCustomCheckbox && (
        <input
          onFocus={handleFocus}
          onBlur={handleBlur}
          checked={checked}
          type="checkbox"
          className={styles.checkboxInputElem}
          {...props}
        />
      )}
      {children}
      {label}
    </label>
  )
}

export default FilterCheckbox
